// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"b9d3b949","answerDecimal":"edff8f60","iconDollar":"ba2af3d6"};